
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/offers/[url]",
      function () {
        return require("private-next-pages/[locale]/offers/[url]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/offers/[url]"])
      });
    }
  